/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Summary_Error2Inputs */

const en_coinvestments_closedeal_summary_error2 = /** @type {(inputs: Coinvestments_Closedeal_Summary_Error2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the deal summary. Please try again.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the deal summary. Please try again." |
*
* @param {Coinvestments_Closedeal_Summary_Error2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_summary_error2 = /** @type {((inputs?: Coinvestments_Closedeal_Summary_Error2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Summary_Error2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_summary_error2(inputs)
});
export { coinvestments_closedeal_summary_error2 as "coInvestments_closeDeal_summary_error" }